import { render, staticRenderFns } from "./BuyDirectModal.vue?vue&type=template&id=246282c1"
import script from "./BuyDirectModal.vue?vue&type=script&lang=js"
export * from "./BuyDirectModal.vue?vue&type=script&lang=js"
import style0 from "./BuyDirectModal.vue?vue&type=style&index=0&id=246282c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports